import * as React from 'react';
import { connect } from 'react-redux';

import { APP_EMAIL } from '../../config';
import { StateType } from '../../reducers';
import { getUserIdSelector } from '../../reducers/AuthenticationReducer/AuthenticationSelector';
import { logErrorService } from '../../shared/services';

import './ErrorBoundary.scss';

interface ErrorCatchProps {
  error: any;
}

interface ErrorCatchStateProps {
  userId: string;
}

type ErrorCatchGeneric = ErrorCatchProps & ErrorCatchStateProps;

class ErrorCatch extends React.Component<ErrorCatchGeneric> {
  render() {
    const error = this.props.error;
    logErrorService(error.message, error);
    const mailRef = `"mailto:${APP_EMAIL}?subject=An Application Error Has Occurred For ${this.props.userId || 'Not Signed In User'}"`;

    return (
      <div className="error-message">
        <div className="error-message__title"> An Application Error Has Occurred. </div>
        <div className="error-message__content">
          Please contact{' '}
          <a className="error-boundary__element-link" href={mailRef}>
            support
          </a>{' '}
          if this problem persists.
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state: StateType): ErrorCatchStateProps => ({
  // @ts-ignore
  userId: getUserIdSelector(state),
});

export default connect<ErrorCatchStateProps, any, any, StateType>(mapStateToProps)(ErrorCatch);
